import { sortBy } from 'lodash-es';

export const sortFontFaces = <
  T extends {
    width: { slug: string; name: string; position: number };
    weight: { slug: string; name: string; position: number };
    style: { slug: string; name: string; position: number };
  },
>(
  fontFaces: readonly T[],
): T[] => {
  return sortBy(
    fontFaces,
    (face) => face.width.position,
    (face) => face.weight.position,
    (face) => face.style.position,
  );
};
